(function () {
  'use strict';

  var drawer, itemsEl, subtotalEl, emptyEl, countEls, toastEl, toastTimer;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function showToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2600);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.classList.add('dyc-drawer-open');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('dyc-drawer-open');
  }

  function updateCountBubbles(count) {
    countEls = countEls || qsa('[data-dyc-cart-count]');
    countEls.forEach(function (el) { el.textContent = count; });
  }

  function renderCart(cart) {
    if (!itemsEl) return;
    updateCountBubbles(cart.item_count);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'block';
    } else {
      if (emptyEl) emptyEl.style.display = 'none';
      itemsEl.innerHTML = cart.items.map(function (item) {
        return (
          '<div class="dyc-cart-drawer__item" data-key="' + item.key + '">' +
            '<div class="dyc-cart-drawer__item-media">' +
              (item.image ? '<img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy">' : '') +
            '</div>' +
            '<div class="dyc-cart-drawer__item-body">' +
              '<div class="dyc-cart-drawer__item-row">' +
                '<strong>' + item.product_title + '</strong>' +
                '<span>' + money(item.final_line_price) + '</span>' +
              '</div>' +
              '<span class="dyc-cart-drawer__item-variant">' + (item.variant_title || '') + '</span>' +
              '<div class="dyc-cart-drawer__item-qty">' +
                '<button type="button" class="dyc-cart-drawer__qty-btn" data-action="dec" data-key="' + item.key + '" data-qty="' + item.quantity + '">\u2212</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" class="dyc-cart-drawer__qty-btn" data-action="inc" data-key="' + item.key + '" data-qty="' + item.quantity + '">+</button>' +
                '<button type="button" class="dyc-cart-drawer__remove" data-action="remove" data-key="' + item.key + '">Remove</button>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (err) {
          throw new Error(err.description || 'Could not add to cart');
        });
      }
      return r.json();
    });
  }

  function handleAddFormSubmit(e) {
    var form = e.target.closest('.dyc-shop__add-form, .dyc-add-form');
    if (!form) return;
    e.preventDefault();

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;

    var btn = form.querySelector('button[type="submit"]');
    var originalText = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding\u2026';
    }

    addToCart(idInput.value, 1)
      .then(function (item) {
        showToast((item.product_title || 'Item') + ' aboard');
        return fetchCart();
      })
      .then(openDrawer)
      .catch(function (err) {
        showToast(err.message || 'Something went wrong');
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
      });
  }

  function handleDrawerClick(e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var key = btn.getAttribute('data-key');
    var action = btn.getAttribute('data-action');

    if (action === 'remove') {
      changeLine(key, 0);
    } else if (action === 'inc') {
      changeLine(key, parseInt(btn.getAttribute('data-qty'), 10) + 1);
    } else if (action === 'dec') {
      var next = parseInt(btn.getAttribute('data-qty'), 10) - 1;
      changeLine(key, Math.max(0, next));
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    drawer = qs('#dyc-cart-drawer');
    itemsEl = qs('#dyc-cart-drawer-items');
    subtotalEl = qs('#dyc-cart-drawer-subtotal');
    emptyEl = qs('#dyc-cart-drawer-empty');
    toastEl = qs('#dyc-cart-toast');

    var menuToggle = qs('[data-dyc-menu-toggle]');
    var mobileMenu = qs('[data-dyc-mobile-menu]');
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function () {
        var isOpen = mobileMenu.classList.toggle('is-open');
        menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
      qsa('a', mobileMenu).forEach(function (link) {
        link.addEventListener('click', function () {
          mobileMenu.classList.remove('is-open');
          menuToggle.setAttribute('aria-expanded', 'false');
        });
      });
    }

    qsa('[data-dyc-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    qsa('[data-dyc-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) closeDrawer();
      });
      drawer.addEventListener('click', handleDrawerClick);
    }

    document.addEventListener('submit', handleAddFormSubmit);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-dyc-thumb]');
      if (!thumb) return;
      var mainImg = qs('#dyc-product-main-image');
      var full = thumb.getAttribute('data-full');
      if (mainImg && full) {
        mainImg.removeAttribute('srcset');
        mainImg.src = full;
      }
    });

    fetchCart();
  });
})();
